export const MODAL_IDS = {
  fpg_assets_modal: 'fpg_assets_modal',
  fpg_docs_modal: 'fpg_docs_modal',
  fpg_assets_warning_modal: 'fpg_assets_warning_modal',
  reporting_mode: 'reporting_mode',
  report_download_modal: 'report_download_modal',
  report_reference_modal: 'report_reference_modal',
  shift_payment_modal: 'shift_payment_modal',
  set_desired_amount: 'set_desired_amount',
  confirm_application_modal: 'confirm_application_modal',
  application_select_modal: 'application_select_modal',
  lender_loan_detail: 'lender_loan_detail',
  lender_application_select_modal: 'lender_application_select_modal',
  compliance_submit_modal: 'compliance_submit_modal',
};
